export default "__VITE_ASSET__WMoNlvWY__"